import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../../httpClient/RestApiService';
import { ISiteSettingsMetadataBySections, ISiteSettingsMetadataBySettings } from '../types/ISiteSettingsMetadata';

function getSiteSettingsMetadataConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: 'exp',
    httpMethod: 'GET',
    endpoint: 'settings/metadata',
  };
}

export type GetSiteSettingsMetadataParams = {
  readonly sections?: string;
  readonly settings?: string;
};

export class GetSiteSettingsMetadataService {
  public static getSectionLevelMetadata(sections: string[]): Promise<ISiteSettingsMetadataBySections> {
    return makeJsonRestApiRequest<void, ISiteSettingsMetadataBySections, GetSiteSettingsMetadataParams>({
      config: getSiteSettingsMetadataConfig(),
      request: null,
      queryParams: { sections: sections.join(',') }
    });
  }

  public static getSiteSettingMetadata(settings: string[]): Promise<ISiteSettingsMetadataBySettings> {
    return makeJsonRestApiRequest<void, ISiteSettingsMetadataBySettings, GetSiteSettingsMetadataParams>({
      config: getSiteSettingsMetadataConfig(),
      request: null,
      queryParams: { settings: settings.join(',') }
    });
  }
}
